import {Directive, EventEmitter, Input, Output} from '@angular/core';
import {Company} from '../../../models/company';

@Directive()
export abstract class RegisterCompanyStepBase {

    @Input() company: Company = new Company();
    @Input() isProcessing = false;

    @Output() persist = new EventEmitter<void>();
    @Output() next = new EventEmitter<void>();
    @Output() back = new EventEmitter<void>();

    persistForm(): void {
        this.persist.emit();
    }

    nextStep(): void {
        this.next.emit();
    }

    previousStep(): void {
        this.back.emit();
    }
}
